import React, { useRef } from "react";
import { insertAtCursor, renderTemplate } from "../../voiceSettings";

/**
 * A text field for a template with {{variables}}: chips insert a variable at
 * the caret, and a grey line shows the text with sample values filled in.
 */
export default function TemplateField({
  label,
  help,
  value,
  onChange,
  variables = [],
  variableDetails = [],
  maxLength,
  rows = 2,
  placeholder,
  disabled = false,
  preview = true,
}) {
  const inputRef = useRef(null);

  const insert = (name) => {
    const element = inputRef.current;
    const insertion = `{{${name}}}`;
    const { value: next, caret } = insertAtCursor(
      value || "",
      element?.selectionStart,
      element?.selectionEnd,
      insertion,
    );
    onChange(next);
    requestAnimationFrame(() => {
      if (element) {
        element.focus();
        element.setSelectionRange(caret, caret);
      }
    });
  };

  const detailFor = (name) =>
    variableDetails.find((variable) => variable.name === name);

  return (
    <div className="oo-field">
      <label>
        {label}
        {maxLength ? ` (up to ${maxLength} characters)` : ""}
      </label>
      {help ? <div className="oo-field-help">{help}</div> : null}
      <textarea
        ref={inputRef}
        rows={rows}
        value={value}
        maxLength={maxLength}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {variables.length ? (
        <div className="oo-var-chips" aria-label="Variables">
          {variables.map((name) => {
            const detail = detailFor(name);
            return (
              <button
                key={name}
                type="button"
                className="oo-var-chip"
                disabled={disabled}
                title={detail ? `${detail.description} — e.g. ${detail.example}` : name}
                onClick={() => insert(name)}
              >
                {`{{${name}}}`}
              </button>
            );
          })}
        </div>
      ) : null}
      {preview && value ? (
        <div className="oo-template-preview">
          <span className="oo-template-preview-label">Preview</span> {renderTemplate(value)}
        </div>
      ) : null}
    </div>
  );
}
